export default "__VITE_ASSET__44a8erOr__"